/**
 * Formats a transcript into sentences and makes sure that abbreviations are not split into sentences.
 */
export const toSentences = (transcript: string) => {
  return transcript.replace(
    /\b(Mr|Mrs|Ms|Miss|Jr|Dr|Doctor|Hi)(\.\s*)|([.!?]\s*)/g,
    (match, abbreviation) => (abbreviation ? match : match + '\n'),
  );
};

/**
 * Formats a transcript for display. Transcripts that already carry line
 * structure (e.g. speaker-separated diarized output) are shown as-is so the
 * real newlines are preserved; flat transcripts (single-speaker dictation,
 * older data, providers without diarization) fall back to sentence-per-line
 * formatting for readability.
 */
export const formatTranscriptForDisplay = (transcript: string) =>
  transcript.includes('\n') ? transcript : toSentences(transcript);
